module.exports = __webpack_public_path__ + "img/L2D_Stecker_Typ_II_150x150.aaaa0ea3.png";